<template>
  <div class="navigation-menu-header">
    <div class="header-row full-width">
      <div class="members-details ri-label">
        <span class="ri-alte ellipsis-text" :class="longHouseholdName ? 'ri-bold-title' : 'ri-medium-bold-headline'">
          {{ memberName }}
        </span>
        <span class="last-updated ri-small-body">עדכון אחרון: {{ lastUpdated }}</span>
      </div>
      <button class="settings-button" @click.stop="openSettings" ref="settings">
        <img :src="require('@/assets/icons/navigation-menu/settings.svg')" alt="הגדרות"/>
      </button>
    </div>
    <trial-state-snackbar class="margin-top-sm" :close-modal="closeModal" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import Segment from '@/Segment';
import TrialStateSnackbar from '@/base-components/app-header/TrialStateSnackbar';

export default {
  name: 'NavigationMenuHeader',
  components: {
    TrialStateSnackbar,
  },
  props: {
    closeModal: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('session', ['householdName', 'numberOfMembers']),
    ...mapGetters('cashflowView', ['budgetUpdatedAt']),
    ...mapState('session', ['activeMember', 'members']),
    memberName() {
      return this.numberOfMembers > 1 ? this.householdName : `${this.activeMember.firstNamePiiValue} ${this.activeMember.lastNamePiiValue}`;
    },
    lastUpdated() {
      const updateHour = moment(this.budgetUpdatedAt)
        .format('H:mm');
      const updateDate = moment(this.budgetUpdatedAt)
        .format('D.MM');
      return `${updateDate} ${updateHour} `;
    },
    longHouseholdName() {
      return this.memberName.length > 14;
    },
  },
  methods: {
    focus() {
      this.$refs.settings.focus();
    },
    openSettings() {
      Segment.trackUserInteraction('NavigationMenu_SettingsClicked');
      this.$router.push({
        name: 'Settings',
        query: this.$route.query,
      });
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import '~@riseupil/base-ui/src/scss/spacings';
@import '~@riseupil/base-ui/src/scss/border-radius';

.navigation-menu-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .header-row {
    display: flex;
    align-items: flex-start;
    column-gap: $ri-spacing-sm;
  }

  .members-details {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    padding-top: 9px;
  }

  .subtitle {
    display: flex;
    flex-direction: column;
    color: $riseup_gray_60;
  }

  .settings-button {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    height: 50px;
    width: 50px;
    background: $riseup_white;
    border: none;
    border-radius: 50%;
    cursor: pointer;
  }
  .last-updated {
    color: #9B9B9B;
  }
}
</style>
